import { createAsyncAction } from '@alycecom/utils';

import { IBaseRequestParams } from '../../../../store/types/Request.types';

import { ICodeData } from './codeData.types';

const prefix = 'ACCEPT_GIFT_CODE/DATA';

export const fetchCodeData = createAsyncAction<IBaseRequestParams, ICodeData>(`${prefix}/FETCH_DATA`);
